(() => {
  const selector = '#pb-course-landing';

  const destroySticky = (root) => {
    if (!root || typeof root.pbCourseStickyCleanup !== 'function') return;
    root.pbCourseStickyCleanup();
    delete root.pbCourseStickyCleanup;
  };

  const initSticky = (root) => {
    if (!root || root.pbCourseStickyCleanup) return;

    const buyBox = root.querySelector('#buyNow');
    const sticky = root.querySelector('[data-sticky-buy]');
    const stickyStart = root.querySelector('[data-sticky-start]');
    if (!buyBox || !sticky || !stickyStart || !('IntersectionObserver' in window)) return;

    let stickyStarted = false;
    let buyBoxVisible = false;
    const updateSticky = () => {
      sticky.classList.toggle('is-hidden', !stickyStarted || buyBoxVisible);
    };

    const startObserver = new IntersectionObserver((entries) => {
      const entry = entries[0];
      stickyStarted = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      updateSticky();
    }, { threshold: 0 });

    const buyBoxObserver = new IntersectionObserver((entries) => {
      buyBoxVisible = entries[0].isIntersecting;
      updateSticky();
    }, { threshold: 0.08 });

    startObserver.observe(stickyStart);
    buyBoxObserver.observe(buyBox);
    root.pbCourseStickyCleanup = () => {
      startObserver.disconnect();
      buyBoxObserver.disconnect();
      sticky.classList.add('is-hidden');
    };
  };

  const initAll = (container = document) => {
    if (container.matches?.(selector)) initSticky(container);
    container.querySelectorAll('#pb-course-landing').forEach(initSticky);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      document.querySelectorAll('#pb-course-landing').forEach(initSticky);
    }, { once: true });
  } else {
    document.querySelectorAll('#pb-course-landing').forEach(initSticky);
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.matches?.(selector)
      ? event.target
      : event.target.querySelector(selector);
    destroySticky(root);
  });
})();
